export const separatorRegex = /[^a-zA-Z0-9]/g;
export const normalizeValueSeparator = (value: string, dateFormat: string): string => {
    // Strip all separators from both value and format
    const valueWithoutSeparators = value.replace(separatorRegex, '');
    const formatWithoutSeparators = dateFormat.replace(separatorRegex, '');

    // If lengths don't match, return value as-is (let validation fail naturally)
    if (valueWithoutSeparators.length !== formatWithoutSeparators.length) {
        return value;
    }

    // Rebuild with the format's separators
    const formatParts = dateFormat.split(/[^a-zA-Z0-9]/);
    const separators = dateFormat.match(separatorRegex) || [];

    let result = '';
    let valueIndex = 0;

    formatParts.forEach((part, i) => {
        // Add the chunk of value corresponding to this format part
        result += valueWithoutSeparators.slice(valueIndex, valueIndex + part.length);
        valueIndex += part.length;

        // Add separator if not the last part
        if (i < formatParts.length - 1) {
            result += separators[i] || '-';
        }
    });

    return result;
};

